import React from "react";
import "./menuInOrbit.scss";
import Text from "componets/atoms/text/text";
import OrbitPlanetDecoration from "componets/atoms/orbitPlanetDecoration";
import "../../../styles/fontSizes.scss";
import CapsuleButton from "componets/atoms/capsuleButton/capsuleButton";
import palette from "styles/palette.scss";
import launchIcon from "SVG/icons/launch.svg";
import expandIcon from "SVG/icons/expand.svg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

/* Estructura de options:
cada option puede ser un vínculo y su dirección sería el campo value
options = {
    categories: [ 
        {categoryName : "", options: [{name: "option11", value: "value11"}, {name: "option12", value: "value12"}, {name: "option13", value: "value13"}]}
    ]
}

type = 1, 2
*/
const MenuInOrbit = ({ options, setOption, selectedOption, type }) => {
  const navigate = useNavigate();
  const [categoryDisplayed, setCategoryDisplayed] = React.useState([]);
  const [firstTime, setFirstTime] = React.useState(true);
  React.useEffect(() => {
    if (firstTime) {
      var auxCategory = [];
      options.categories.map(() => {
        auxCategory.push(true);
      });
      setCategoryDisplayed([...auxCategory]);
      setFirstTime(!firstTime);
    }
  }, [firstTime]);

  const color = {
    categoryColor: type == 2 ? palette.darkGreen : palette.darkBrown,
    optionColor: type == 2 ? palette.green : palette.brown,
  };
  function handleChangeOption(e) {
    setOption(e.target.value);
    navigate(`../${e.target.value}`);
  }
  function handleCategory(e) {
    var auxCategory = [...categoryDisplayed];
    auxCategory[e.target.value] = !auxCategory[e.target.value];
    setCategoryDisplayed([...auxCategory]);
  }
  return (
    <>
      <div className="menu-orbit__container font-size--1">
        {type && type == 2 ? (
          <div className="menu-orbit__orbits">
            <OrbitPlanetDecoration
              color={palette.darkGreen}
              type={3}
              rotationZ={"60Deg"}
            />
            <OrbitPlanetDecoration
              color={palette.darkGreen}
              type={1}
              rotationZ={"90Deg"}
            />
          </div>
        ) : (
          <div className="menu-orbit__orbits">
            <OrbitPlanetDecoration type={3} rotationZ={"60Deg"} />
            <OrbitPlanetDecoration type={1} rotationZ={"90Deg"} />
          </div>
        )}

        <div className="menu-orbit__buttons">
          {options.categories &&
            options.categories.map((category, index) => (
              <React.Fragment key={index}>
                <CapsuleButton
                  value={index}
                  handle={handleCategory}
                  className="menu-orbit__category-button"
                  color={palette.white}
                  bgColor={color.categoryColor}
                >
                  <Text type="h">{category.categoryName}</Text>
                  <img
                    style={{
                      marginLeft: "1em",
                      width: "1.5em",
                      height: "1.5em",
                      pointerEvents: "none",
                    }}
                    src={expandIcon}
                    alt={"icono de vínculo externo"}
                  ></img>
                </CapsuleButton>
                <div
                  className={`menu-orbit__buttons ${
                    categoryDisplayed[index] == false
                      ? "menu-orbit__buttons--hiden"
                      : ""
                  }`}
                >
                  {category.options.map((option, index) =>
                    option.isLink ? (
                      <CapsuleButton
                        key={index}
                        handle={(e) => window.open(e.target.value)}
                        value={option.value}
                        color={palette.white}
                        bgColor={color.optionColor}
                      >
                        <Text type="p">{option.name}</Text>
                        <img
                          style={{
                            marginLeft: "1em",
                            width: "1.5em",
                            height: "1.5em",
                            pointerEvents: "none",
                          }}
                          src={launchIcon}
                          alt={"icono de vínculo externo"}
                        ></img>
                      </CapsuleButton>
                    ) : (
                      <CapsuleButton
                        key={index}
                        handle={handleChangeOption}
                        value={option.value}
                        color={palette.white}
                        bgColor={
                          selectedOption === option.value
                            ? color.categoryColor
                            : color.optionColor
                        }
                      >
                        <Text textSize={2} type="p">
                          {option.name}
                        </Text>
                      </CapsuleButton>
                    )
                  )}
                </div>
              </React.Fragment>
            ))}
          {options.aditionalButtons && (
            <div className="menu-orbit__aditional-buttons">
              <br />
              <br />
              <Text type="h" textSize={1}>
                Consulta también:
              </Text>
              {options.aditionalButtons.map((btnData, index) => (
                <CapsuleButton
                  key={index}
                  handle={() => window.open(btnData.link)}
                  color={palette.white}
                  bgColor={palette.darkBrown}
                  textSize={1}
                >
                  {btnData.name}
                </CapsuleButton>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MenuInOrbit;
